/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsControllerFindSellerPublicProfileQueryResponse,
  TelegramProductsControllerFindSellerPublicProfilePathParams,
  TelegramProductsControllerFindSellerPublicProfile401,
} from '../../types/TelegramProductsControllerFindSellerPublicProfile.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsFindSellerPublicProfile } from '../../methods/telegramProductsFindSellerPublicProfile.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsFindSellerPublicProfileQueryKey = (
  sellerPublicProfileId: TelegramProductsControllerFindSellerPublicProfilePathParams['sellerPublicProfileId'],
) =>
  [
    {
      url: '/api/telegram/products/seller/:sellerPublicProfileId',
      params: { sellerPublicProfileId: sellerPublicProfileId },
    },
  ] as const;

export type TelegramProductsFindSellerPublicProfileQueryKey = ReturnType<
  typeof telegramProductsFindSellerPublicProfileQueryKey
>;

export function telegramProductsFindSellerPublicProfileQueryOptions(
  sellerPublicProfileId: TelegramProductsControllerFindSellerPublicProfilePathParams['sellerPublicProfileId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsFindSellerPublicProfileQueryKey(sellerPublicProfileId);
  return queryOptions<
    TelegramProductsControllerFindSellerPublicProfileQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindSellerPublicProfile401>,
    TelegramProductsControllerFindSellerPublicProfileQueryResponse,
    typeof queryKey
  >({
    enabled: !!sellerPublicProfileId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsFindSellerPublicProfile(sellerPublicProfileId, config);
    },
  });
}

/**
 * {@link /api/telegram/products/seller/:sellerPublicProfileId}
 */
export function useTelegramProductsFindSellerPublicProfile<
  TData = TelegramProductsControllerFindSellerPublicProfileQueryResponse,
  TQueryData = TelegramProductsControllerFindSellerPublicProfileQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsFindSellerPublicProfileQueryKey,
>(
  sellerPublicProfileId: TelegramProductsControllerFindSellerPublicProfilePathParams['sellerPublicProfileId'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsControllerFindSellerPublicProfileQueryResponse,
        ResponseErrorConfig<TelegramProductsControllerFindSellerPublicProfile401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsFindSellerPublicProfileQueryKey(sellerPublicProfileId);

  const query = useQuery(
    {
      ...telegramProductsFindSellerPublicProfileQueryOptions(sellerPublicProfileId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsControllerFindSellerPublicProfile401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
